export class PromoCodePricing {
    promoCodeName: string;
    clubCode: string;
    grandTotal: number;

    constructor(promoCodeName: string, clubCode: string, grandTotal: number) {
        this.promoCodeName = promoCodeName;
        this.clubCode = clubCode;
        this.grandTotal = grandTotal;
    }
}

export class PromoCode {
    promoCodeKey?: number;
    promoCodeName: string;
    clubCode: string;
    promoAmount: number;
    promoPercentage: number;
    promoStartDate: any;
    promoEndDate: any;

    constructor(promoCodeName: string, clubCode: string, promoAmount: number, promoPercentage: number, promoStartDate: any, promoEndDate: any) {
        this.promoCodeName = promoCodeName;
        this.clubCode = clubCode;
        this.promoAmount = promoAmount;
        this.promoPercentage = promoPercentage;
        this.promoStartDate = promoStartDate;
        this.promoEndDate = promoEndDate;
    }
}
